import { fetchRecommendedTours, getTourKey } from 'actions/RecommendationActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useMemo } from 'react'

export function useLereTourRecommendation(
  enabled: boolean,
  offerId: string,
  departureYear?: number,
  departureMonth?: number,
  offerType?: Array<App.Tours.V2ProductType>,
) : App.RecommendationOfferState | undefined {
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (enabled) {
      // currently LERE API does not support occupancy filter, only time
      dispatch(fetchRecommendedTours(offerId, departureYear, departureMonth, offerType))
    }
  }, [dispatch, enabled, offerId, departureYear, departureMonth, offerType])

  const region = useAppSelector(state => state.geo.currentRegionCode)

  const key = useMemo(() => {
    if (enabled) {
      return getTourKey(offerId, region, departureYear, departureMonth)
    }
    return ''
  }, [enabled, offerId, region, departureYear, departureMonth])

  const lereTourRecos = useAppSelector(state => state.recommendations.tour[key])

  return lereTourRecos
}
